















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppConstants, Models, apiService, Interfaces } from '@/core/Export'
import SignaturePad from 'signature_pad'
import $ from 'jquery'
import store from '@/store'
@Component({
  components: {},
})
export default class GreenRoutePage extends Vue {
  currentStep: string = 'ApproveTerms'
  signaturePad: any = null
  signatureCanvasElm: any = null
  isSignDialogVisible: boolean = false
  isApproveButtonPressed: boolean = false
  signatureImgSrc: any = null
  isRequestDataReady: boolean = false
  poupWidth = 718
  $q

  constructor() {
    super()
  }

  created() {
    let isFrom1312Form = Boolean(this.$route.query.isFrom1312Form);
    if (!isFrom1312Form) {
      this.onGetNewRequestData()
    } else {
      this.isRequestDataReady = true
    }
  }

  onGetNewRequestData() {
    this.isRequestDataReady = false
    this.appEnv.isBusy = true
    apiService
      .post('Request/CreateNewRequest', {
        personId: this.appEnv.requestParams.personId,
        year: this.appEnv.requestParams.year,
      })
      .then((res) => {
        let response = res as Interfaces.ICallResult
        if (response && response.isSuccess) {
          this.tRequestModel = response.result["requestDto"];
          this.isRequestDataReady = true
        } else {
          this.appEnv.showErrorDialog(response.msgs.errors)
        }
        this.appEnv.isBusy = false
      })
      .catch((err) => {
        this.appEnv.isBusy = false
      })
  }

  onSaveRequest() {
    if (!this.signaturePad || this.signaturePad.isEmpty()) {
      this.$q.notify({
        color: 'negative',
        message: 'חובה לחתום',
        icon: 'warning',
        position: 'center',
      })
      return
    }
    this.onPrepareRequestForSave()
    this.appEnv.isBusy = true
    apiService
      .post('Request/UpdateRequest', this.tRequestModel)
      .then((res) => {
        let response = res as Interfaces.ICallResult
        if (response && response.isSuccess) {
          this.onUpdatePaymentDetails()
        } else {
          this.appEnv.showErrorDialog(response.msgs.errors)
          this.appEnv.isBusy = false
        }
      })
      .catch((err) => {
        this.appEnv.isBusy = false
      })
  }

  onUpdatePaymentDetails() {
    apiService
      .post('Request/UpdatePaymentDetails', {
        issuerPaymentCode: 'Resident',
        requestId: this.tRequestModel.id,
      })
      .then((res) => {
        let response = res as Interfaces.ICallResult
        if (response && response.isSuccess) {
          this.onNavigateToApprovalPage()
        } else {
          this.appEnv.showErrorDialog(response.msgs.errors)
        }
        this.appEnv.isBusy = false
      })
      .catch((err) => {
        this.appEnv.isBusy = false
      })
  }

  onNavigateToApprovalPage() {
    this.appEnv.canViewRequestApprovePage = true
    this.appEnv.requestParams.requestNo = this.tRequestModel.requestNo
    this.appEnv.requestParams.requestId = this.tRequestModel.id
    this.$router.push({
      name: AppConstants.Routes.Approve,
    })
    this.appEnv.canViewRequestRouteGreenPage = false
  }

  onPrepareRequestForSave() {
    this.tRequestModel.detailsApprovmentSignature = JSON.stringify(
      this.signaturePad.toData()
    )
    this.tRequestModel.isDraft = false
  }

  onIsTermsApproved(value) {
    if (value) {
      this.currentStep = 'SignTerms'
    }
  }

  onOpenSignDialog() {
    this.isSignDialogVisible = true
    setTimeout(() => {
      this.signatureCanvasElm = document.getElementById('signature_pad')
      this.signaturePad = new SignaturePad(this.signatureCanvasElm)
      this.poupWidth = $('.sign_dialog').width() - 32
    }, 0)
  }

  onCloseSignDialog(isApprove) {
    this.isApproveButtonPressed = isApprove
    if (isApprove && this.isSignaturePadEmpty) {
      return
    } else {
      this.signatureImgSrc = this.signaturePad.toDataURL('image/png')
    }
    this.isApproveButtonPressed = false
    this.isSignDialogVisible = false
  }

  get isSignaturePadEmpty() {
    return this.isApproveButtonPressed && this.signaturePad.isEmpty()
  }

  get propgressBarValue() {
    if (this.currentStep == 'ApproveTerms') {
      return 0.5
    } else if (this.currentStep == 'SignTerms') {
      return 1
    } else {
      return 0
    }
  }

  get personFullName() {
    return (
      this.tRequestModel.requestFormObj.firstName +
      ' ' +
      this.tRequestModel.requestFormObj.lastName
    )
  }

  set tRequestModel(values) {
    store.commit('updateTRequestModel', values)
  }

  get tRequestModel() {
    return store.getters.tRequestModel
  }

  get paymentAmount() {
    return this.systemData.systemSettings.amount;
  }

  get isPaymentRequired() {
    return this.systemData.systemSettings.isPaymentRequired;
  }

  get refferResidentToDep() {
    var val;
    if (this.systemData && this.systemData["systemSettings"]) {
      val =  this.systemData["systemSettings"].refferResidentToDep;
    } 
    if(!val) val = "למחלקת מרכז לשירות לתושב";
    return val;
  }

  get systemData() {
    return store.getters.systemData;
  }

  get appEnv() {
    return store.getters.appEnv
  }
}
